<template>
  <div>
    <el-card
      class="card-container"
      shadow="never"
    >
      <CardHeader
        slot="header"
        title="Quản lý Media"
        :total="total"
        :size="'small'"
        :selected-file-type="selectedFileType"
        :permission="permission"
        @create="handleCreate"
        @refresh="handleRefresh"
      />
      <div>
        <CardFilter
          :file-type="fileType"
          :search-text="searchText"
          :file-types="fileTypes"
          @search="handleSearch"
        />
        <CardList
          :data="data"
          :loading="loading"
          :selected-file-type="selectedFileType"
          :permission="permission"
          @update="handleUpdate"
          @delete="handleDelete"
        />
        <el-row
          type="flex"
          align="middle"
          justify="end"
          class="mt-l"
        >
          <el-pagination
            background
            :current-page="page"
            :page-sizes="[10, 20, 50, 100, 500, 1000]"
            :page-size="pageSize"
            :total="total"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleChangePageSize"
            @current-change="handleChangePage"
          />
        </el-row>
      </div>
    </el-card>
    <UploadFilesPopup
      v-if="uploadVisible"
      :visible="uploadVisible"
      :selected-file-type="selectedFileType"
      @close="() => (uploadVisible = false)"
      @reload="listData"
    />
    <UpdateFormPopup
      v-if="formVisible"
      :visible="formVisible"
      :item="selectedItem"
      @close="() => (formVisible = false)"
      @reload="listData"
    />
  </div>
</template>

<script>
import CardFilter from "./components/CardFilter.vue";
import CardHeader from "./components/CardHeader.vue";
import CardList from "./components/CardList.vue";
import UploadFilesPopup from "../../components/popups/UploadFiles.vue";
import UpdateFormPopup from "./popups/UpdateForm.vue";

import fileServices from "@/services/file";
import organizationServices from "@/services/organization";
import constants from "@/config/constants";
import { notification } from "@/utils/common";
import { filePer } from "@/utils/permission";

export default {
  name: "FilesManage",
  components: {
    CardHeader,
    CardFilter,
    CardList,
    UploadFilesPopup,
    UpdateFormPopup,
  },
  data() {
    return {
      loading: false,
      searchText: "",
      page: 1,
      pageSize: constants.PAGE_SIZE,
      total: 0,
      data: [],
      selectedItem: null,
      formVisible: false,
      uploadVisible: false,
      fileTypes: constants.FILE_TYPES,
      fileType: constants.FILE_TYPE.IMAGE,
      permission: filePer(),
      organizationId: organizationServices.getCurrentOrg()?.id
    };
  },
  computed: {
    selectedFileType() {
      return this.fileTypes.find((t) => t.key === this.fileType);
    },
    params() {
      const _params = {
        offset: (this.page - 1) * this.pageSize,
        limit: this.page * this.pageSize,
        locale: "vi",
      };
      _params.filters = {
        file_type: this.fileType,
        organization_id: this.organizationId,
      };
      if (this.searchText) {
        _params.filters[`extra.name`] = { $regex: this.searchText }
      }
      return _params;
    },
  },
  beforeMount() {
    this.listData();
  },
  methods: {
    listData() {
      this.loading = true;
      fileServices
        .list(this.params)
        .then((response) => {
          this.data = response.items.map((item, index) => ({
            ...item,
            stt: index + 1 + this.pageSize * (this.page - 1),
          }));
          this.total = response.meta.total;
          this.loading = false;
        })
        .catch(() => {
          this.data = [];
          this.loading = false;
        });
    },
    handleCreate() {
      this.uploadVisible = true;
    },
    handleUpdate(item) {
      this.selectedItem = item;
      this.formVisible = true;
    },
    handleDelete(item) {
      this.$confirm(`Bạn có chắc chắn muốn xoá không?`, "Xác nhận", {
        confirmButtonText: "Xoá",
        cancelButtonText: "Huỷ",
        type: "warning",
      }).then(() => {
        fileServices
          .remove(item)
          .then(() => {
            if (this.data.length === 1 && this.page > 1) {
              this.page = this.page - 1;
            }
            this.listData();
            notification(
              this,
              "success",
              "delete",
              this.selectedFileType.label
            );
          })
          .catch(() => {
            notification(this, "error", "delete", this.selectedFileType.label);
          });
      });
    },
    handleSearch(values) {
      this.fileType = values.fileType;
      this.searchText = values.searchText;
      this.page = 1;
      this.listData();
    },
    handleRefresh() {
      this.selectedItem = null;
      this.page = 1;
      this.searchText = "";
      this.listData();
    },
    handleChangePage(page) {
      this.page = page;
      this.listData();
    },
    handleChangePageSize(size) {
      this.page = 1;
      this.pageSize = size;
      this.listData();
    },
  },
};
</script>

<style lang="scss"></style>
